var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJungle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.886 0l.016.017C3.296.434 10.837 8.545 7.695 15c0 0-2.263-2.928-4.979-4.264 0 0 .453-3.955-2.716-6.575 0 0 4.3 1.85 5.206 4.726l.004-.017C5.275 8.582 6.1 4.6 2.886 0zM15 3.75s-3.225 2.877-2.66 6.421c0 0-2.263 1.336-2.659 2.158 0 0 .227-6.216 5.319-8.579zM11.82 0S9.33 4.315 9.555 7.5c0 0-.51.72-.68 1.336 0 0-.622-2.363-1.131-2.928 0 0 2.094-4.059 4.074-5.908z",
    fill: "#FFF",
    fillRule: "evenodd"
  })));
}
export default __webpack_public_path__ + "static/svg/roles/jungle.svg";
export { SvgJungle as ReactComponent };